import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';

const state = {
  selectedPool: null,
  transactions: null,
  transactionParams: null,
  transactionCount: null
}

const mutations = {
  selectPool(state, pool) {
    state.selectedPool = pool;
  },
  transactions(state, transactions) {
    state.transactions = transactions;
  },
  transactionParams(state, params) {
    state.transactionParams = params;
  },
  transactionCount(state, count) {
    state.transactionCount = count;
  }
}

const getters = {
  selectedPool: () => state.selectedPool,
  transactions: () => state.transactions,
  transactionCount: () => state.transactionCount
}

const actions = {
  async createPool({}, pool) {
    try {
      await ziperase.createPool(pool);
      notify().success('Success! Created a new pool.');
      return true;
    } catch (error) {
      let errorMessage = null;
      if (errorHandler.isConflictError(error)) {
        errorMessage = errorHandler.getConflictErrorMessage(error);
      }
      notify().error(errorMessage || 'Failed to create pool.');
    }
    return false;
  },
  async fetchTransactions({ commit }, params) {
    try {
      commit('transactionParams', params);
      commit('transactions', []); // clear transactions so not shown for wrong pool
      const response = await ziperase.fetchTransactions(params.pool_id, params.params);
      commit('transactions', response.data.data);
      commit('transactionCount', response.data.pagination.count);
    } catch (error) {
      notify().error('Failed to retrieve transactions.');
    }
  },
  async refetchTransactions({ dispatch, state }) {
    let params = state.transactionParams || {};
    await dispatch('fetchTransactions', params);
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}